import { render, staticRenderFns } from "./management-library-task-category-form.vue?vue&type=template&id=d80280bc&"
import script from "./management-library-task-category-form.vue?vue&type=script&lang=js&"
export * from "./management-library-task-category-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports